import FacialRoutes from "@/modules/device/routers/facial_device.router";

// Device Module routes
export default [...FacialRoutes];
